import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=7968450e&scoped=true&"
import script from "./PhoneIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PhoneIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968450e",
  null
  
)

export default component.exports